import { Eye, EyeOff } from 'lucide-react';
import { usePrivacy } from '../context/PrivacyContext';

export const PrivacyToggle = ({ className = '' }) => {
  const { hidden, toggle } = usePrivacy();
  return (
    <button
      type="button"
      onClick={toggle}
      title={hidden ? 'Show production & commission numbers' : 'Blur production & commission numbers'}
      aria-pressed={hidden}
      className={`group flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-bold shadow-sm backdrop-blur-md transition-colors ${
        hidden
          ? 'border-[#23ACD5]/40 bg-[#0B1437] text-[#00E5FF] hover:bg-[#111C44]'
          : 'border-[#E9EDF7] bg-white/90 text-[#2B3674] hover:bg-[#F4F7FE]'
      } ${className}`}
      data-testid="privacy-toggle"
    >
      {hidden ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      <span className="hidden sm:inline">{hidden ? 'Numbers hidden' : 'Hide numbers'}</span>
    </button>
  );
};
